import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=db3fc3fe&scoped=true&"
import script from "./Crear.vue?vue&type=script&lang=js&"
export * from "./Crear.vue?vue&type=script&lang=js&"
import style0 from "./Crear.vue?vue&type=style&index=0&id=db3fc3fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3fc3fe",
  null
  
)

export default component.exports